export enum SubscriptionCodeStatus {
    available = 'available',
    expired = 'expired',
    pendingConfirmation = 'pendingConfirmation',
    used = 'used',
}
